export const hslToRgb = (h, s, l) => {
  const sat = s / 100;
  const light = l / 100;
  const c = (1 - Math.abs(2 * light - 1)) * sat;
  const x = c * (1 - Math.abs(((h / 60) % 2) - 1));
  const m = light - c / 2;

  let r = 0;
  let g = 0;
  let b = 0;

  if (h < 60) [r, g, b] = [c, x, 0];
  else if (h < 120) [r, g, b] = [x, c, 0];
  else if (h < 180) [r, g, b] = [0, c, x];
  else if (h < 240) [r, g, b] = [0, x, c];
  else if (h < 300) [r, g, b] = [x, 0, c];
  else [r, g, b] = [c, 0, x];

  return {
    r: Math.round((r + m) * 255),
    g: Math.round((g + m) * 255),
    b: Math.round((b + m) * 255),
  };
};

export const rgbToHex = ({ r, g, b }) =>
  `#${[r, g, b].map((v) => v.toString(16).padStart(2, '0')).join('')}`;

export const hslToHex = (h, s, l) => rgbToHex(hslToRgb(h, s, l));

export const randomColor = () => ({
  h: Math.floor(Math.random() * 360),
  s: Math.floor(Math.random() * 70) + 25,
  l: Math.floor(Math.random() * 55) + 22,
});

const MAX_RGB_DISTANCE = Math.sqrt(3 * 255 * 255);

export const colorDistance = (a, b) => {
  const dr = a.r - b.r;
  const dg = a.g - b.g;
  const db = a.b - b.b;
  return Math.sqrt(dr * dr + dg * dg + db * db);
};

export const scoreFromDistance = (distance) =>
  Math.max(0, Math.round(100 - (distance / MAX_RGB_DISTANCE) * 100));

export const COLOR_MEMORY_POINT_THRESHOLD = 95;

export const scoresColorMemoryPoint = (score) => {
  const n = Number(score);
  return Number.isFinite(n) && n >= COLOR_MEMORY_POINT_THRESHOLD;
};

export const getColorMemoryRank = (score) => {
  const n = Number(score);
  const value = Number.isFinite(n) ? n : 0;

  if (value >= 100) {
    return {
      animal: 'Peregrine Falcon',
      message:
        "Peregrine Falcon! 🦅 Perfect match. Are you even human? Those sliders didn't stand a chance.",
    };
  }
  if (value >= 95) {
    return {
      animal: 'Falcon',
      message:
        "Falcon-level memory! 🦅 That's actually impressive. You saw the color and proved it. One more nudge for a perfect 100?",
    };
  }
  if (value >= 85) {
    return {
      animal: 'Cheetah',
      message:
        "Cheetah? 🐆 Don't. Close-ish isn't a high score. You almost had it, which is a fancy way of saying you didn't. Come back at 95.",
    };
  }
  if (value >= 70) {
    return {
      animal: 'Wolf',
      message:
        "Wolf rank? 🐺 Barely. A little above average isn't a personality. The pack would scroll past this and not look back.",
    };
  }
  if (value >= 50) {
    return {
      animal: 'Rabbit',
      message:
        "Rabbit rank! 🐇 Mid at best. Don't get hoppy — matching the 'vibe' isn't matching the color. Average with extra steps.",
    };
  }
  if (value >= 30) {
    return {
      animal: 'Turtle',
      message:
        "Turtle mode! 🐢 Slow, muddy, and proud of it. You remembered there was a color. That's the highlight.",
    };
  }
  return {
    animal: 'Snail',
    message:
      "Snail rank! 🐌 Did you take a nap during the 5 seconds? That guess is a different color family. Even your grandma's memory would land closer.",
  };
};

export const scoreLabel = (score) => getColorMemoryRank(score).message;
